/**
 * manifest.ts — the BAKED release manifest.
 *
 * `version.json` (repo root — like install.sh + docker-compose.release.yml,
 * the install artifacts the Dockerfile copies into the nginx html dir;
 * Vite forbids importing from public/) is generated at release time
 * (scripts/make-version.mjs, wired as npm's prebuild hook): the frontend
 * source md5 and the release's api/jupyter image digests. The deploy serves
 * it at /version.json and the import below bakes THIS build's copy into the
 * bundle (the ConnectivityWizard's compose import is the precedent).
 *
 * Comparison semantics (see useVersionCheck):
 * - frontend drift: the BAKED sourceMd5 (what this browser tab runs) vs the
 *   SERVED manifest's sourceMd5 (what the deploy runs now) — dokku redeploys
 *   the SPA image, a stale tab must offer a reload.
 * - stack drift: the SERVED manifest's image digests (the current release)
 *   vs the LIVE digests the backend reports (GET /api/version) — the baked
 *   digests are never used for this (they can be stale in dev builds).
 *
 * The pure helpers live in compare.ts (vite-free — node-testable); this
 * module re-exports them for callers that already import from here.
 */

import raw from '../../version.json?raw';

import { parseManifest, type VersionManifest } from './compare';

export {
  digestsDiffer,
  parseManifest,
  shortHash,
  frontendDrift,
  stackDrift,
} from './compare';
export type { LiveServiceInfo, LiveVersionInfo, VersionManifest } from './compare';

/** What THIS bundle was built from (null only if the baked manifest is
 *  unreadable — the checker then stays silent). */
export const bakedManifest: VersionManifest | null = parseManifest(raw);

/** The app version for About/Settings surfaces. */
export const appVersion: string = bakedManifest?.version ?? '0.1.0';
